<template>
  <div class="vx-row mb-2 mt-1">
    <div class="vx-col w-full center" style="text-align:center">
      <img
      @click="triggerUpload()"
        style="cursor:pointer"
        src="@/assets/images/logo/addFile.png"
        alt="content-img"
        class="responsive card-img-top"
      />
 <h5 class="mt-2 center" style="height: 50px; overflow: auto">
              ADD DOCUMENTS
            </h5>
     <input style="display:none" @change="submitFiles()" type="file" ref="file" multiple="multiple" />
       
    </div>
  </div>
</template>
<script>
import axios from "@/axios.js";
import { bus } from "../../../main";
export default {
  headers: {
    "access-token": "Bearer " + localStorage.getItem("token"),
    "Content-Type": "multipart/form-data",
  },

  props: {
    baseUrl: String,
    uploadEndpoint: String,
    index: String,

    value: String,
    jointId: Number,
    validation: "",
  },

  data() {
    return {
      localVal: "",
      name: "",
    };
  },

  computed: {
    uploadUrl() {
      return this.uploadEndpoint;
    },
  }, 
  created() {
      
  },

  methods: {
      
     triggerUpload() {
      this.$refs.file.click();
      
    },
    submitFiles() {
      let formData = new FormData();

      for (var i = 0; i < this.$refs.file.files.length; i++) {
        let file = this.$refs.file.files[i];
        formData.append("files[" + i + "]", file);
      }

      formData.append("id", this.jointId);

      let that = this;
      axios
        .post(this.uploadUrl, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(function () { 
           that.$emit("refresh", "");

        })
        .catch(function () {});
    },
    successUpload(event) {
      if (this.localVal == "") {
        this.localVal = event.currentTarget.response;
      } else {
        this.localVal = this.localVal + "|" + event.currentTarget.response;
      }
    },
    changeHandler() {
      // this.$emit("error", this.errors.errors);
      this.$validator.validateAll().then((result) => {
        this.$emit("error", { index: this.index, value: result });
      });
    },
    onFileChanged(event) {
      const file = event.target.files[0];
      this.$emit("error", { index: this.index, value: true });
      this.$emit("input", { index: this.index, value: file });
    },
  },
};
</script>

